import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

interface BootcampCourse {
image: string;
title: string;
highlight: string;
features:string[];
price: string;
bookLink?: string; // Optional link for booking
detailsLink?: string; // Optional link for more details
}

@Component({
    selector: 'app-bootcamp',
    templateUrl: './bootcamp.component.html',
    styleUrls: ['./bootcamp.component.css'],
    standalone: false
})
export class BootcampComponent  {

  
  private observer: any = null;
  constructor(private router: Router) {}
 
  ngOnInit(): void {
    this.loadGoogleFonts();
  }
 
  ngAfterViewInit(): void {
    this.initScrollReveal();
  }
 
  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
 
  private loadGoogleFonts(): void {
    if (document.getElementById('bc-google-fonts')) { return; }
    const link = document.createElement('link');
    link.id   = 'bc-google-fonts';
    link.rel  = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Fredoka+One&family=Nunito:wght@400;600;700;800;900&display=swap';
    document.head.appendChild(link);
  }
 
  private initScrollReveal(): void {
    var IoConstructor: any = (window as any).IntersectionObserver;
 
    if (!IoConstructor) {
      var all = document.querySelectorAll('.bc-reveal.bc-hidden');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.remove('bc-hidden');
        all[i].classList.add('visible');
      }
      return;
    }
 
    var self = this;
    var options = { threshold: 0.12, rootMargin: '0px 0px -40px 0px' };
 
    this.observer = new IoConstructor(function(entries: any[]) {
      entries.forEach(function(entry: any) {
        if (entry.isIntersecting) {
          var el: HTMLElement = entry.target as HTMLElement;
          el.classList.remove('bc-hidden');
          el.classList.add('visible');
          if (self.observer) { self.observer.unobserve(el); }
        }
      });
    }, options);
 
    var elements = document.querySelectorAll('.bc-reveal.bc-hidden');
    for (var j = 0; j < elements.length; j++) {
      this.observer.observe(elements[j]);
    }
  }
 
  scrollToBook(): void {
    window.location.href = 'https://zfrmz.in/ShF0xJAOzuCmkDyIis9p';
  }
 
  downloadBrochure(): void {
   window.location.href = 'https://drive.google.com/uc?export=download&id=1557efTpoQw9GEKX5xgotTnQW0i8SfQ-a';
  }

}
